/*
 * @Author: w-lichenxia-8caYS w_lichenxia@xiwang.com
 * @Date: 2024-06-22 10:19:15
 * @LastEditors: Shusheng
 * @LastEditTime: 2024-08-19 15:00:13
 * @FilePath: /teacher-desk/src/log/index.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { getBrand } from '@/brandConfig';
import { Brand } from '@/brandConfig/typings';
import { logModuleType, logPageType } from '@/log/pages/myClass';
import type { IBusData } from '@xwfe/web-track-browser';
import XwLog from '@xwfe/web-track-browser';
export * from './pages/newMyClass';
export * from './pages/rowCom';
export * from './pages/survey';
export * from './pages/technologyLog';

let xwInstance: any = null;
// let counselor_id = 'default';
// const commonData = {};
// const getCounselorId = () => {
//   return counselor_id !== 'default' ? counselor_id : sessionStorage.getItem('teacher_id') || 'default';
// };

const LogProject = {
  [Brand.Xwx as string]: 'xw-fe-logs',
  [Brand.Xwsy as string]: 'xw-fe-xi-logs',
  [Brand.Xwyk as string]: 'yk-fe-logs'
};

const getHrefRoute = () => {
  const href = window.location.href;
  return href.includes('?') ? href.split('?')[0] : href;
};
const getLogProject = () => {
  return LogProject[getBrand()];
};

const initXWLog = () => {
  if (xwInstance) return xwInstance;
  const logOpts = {
    project: getLogProject(),
    logstore: 'xw-fe-teacherdesk', // 日志库
    debug: process.env.NODE_ENV === 'prod' ? false : true,
    business_type: 'xw-fe-teacherdesk', // 项目唯一标识，todo:需要改成自己的项目名称哦
    env_type: process.env.NODE_ENV === 'prod' ? XwLog.EVNTYPE.Production : XwLog.EVNTYPE.Development,
    source_type: XwLog.SOURCETYPE.WEB
  };
  xwInstance = new XwLog(logOpts);
  return xwInstance;
};
const getPageAndModuleType = (route: any) => {
  let logData = {};
  let path: any = route.split('/'); // 我的班级、新体验模式通过前面路由区分
  const origin = path[2];

  if (path[1] === 'enrollment') {
    // 我的私海、我的私海（高）通过后面路由区分
    path = path[2];
  } else {
    path = path[1];
  }
  logData = {
    page_type: logPageType[path] || path.toString(), // 页面类型1.新体验模式2.我的班级3.我的私海4.我的私海（高）
    module_type: logModuleType[origin] || origin // 模块类型 1.班级学员2.讲次表现3.全讲次表现
  };
  return logData;
};

// 发送埋点
export function sendLog(id: string, params = {}, path?: any) {
  const xwlog = initXWLog();
  // 日志埋点数据
  let logData = {};
  if (path) {
    logData = getPageAndModuleType(path);
  }
  console.log(logData, id, params, '获取类型---==---===');
  if (!id) return;
  const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
  const routerPage = getHrefRoute();
  console.log('----userInfo----', userInfo);
  const workCode = userInfo?.workcode;
  const commonStore = {
    router_page: routerPage,
    counselor_id: userInfo?.teacher_id,
    brand: getBrand(),
    work_code: workCode,
    ...userInfo
  };
  xwlog.sendImmediate({
    user_id: workCode,
    click_id: id,
    ...commonStore,
    ...params,
    ...logData
  });
}

// 发送埋点
export function sendLogLazy(id: string, params = {}, path?: any) {
  const xwlog = initXWLog();
  // 日志埋点数据
  let logData = {};
  if (path) {
    logData = getPageAndModuleType(path);
  }
  console.log(logData, id, params, '获取类型---==---===');
  if (!id) return;
  const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
  const routerPage = getHrefRoute();
  console.log('----userInfo----', userInfo);
  const workCode = userInfo?.workcode;
  const commonStore = {
    router_page: routerPage,
    counselor_id: userInfo?.teacher_id,
    brand: getBrand(),
    work_code: workCode,
    ...userInfo
  };
  xwlog.send({
    user_id: workCode,
    click_id: id,
    ...commonStore,
    ...params,
    ...logData
  });
}

export function sendBatchLog(
  logParams: Array<{ id: string; params: Record<string, unknown> }>,
  options: {
    immediate?: boolean;
    path?: any;
  } = {}
) {
  if (!logParams.length || logParams.some((params) => !params.id)) {
    return;
  }

  const xwxLog = initXWLog();
  // 日志埋点数据
  let logData = {};
  if (options.path) {
    logData = getPageAndModuleType(options.path);
  }
  const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
  const routerPage = getHrefRoute();
  console.log('----userInfo----', userInfo);
  const workCode = userInfo?.workcode;
  const commonStore = {
    router_page: routerPage,
    counselor_id: userInfo?.teacher_id,
    brand: getBrand(),
    work_code: workCode,
    ...userInfo
  };
  const reportData: IBusData[] = [];
  logParams.forEach(({ id, params }) => {
    reportData.push({
      user_id: workCode,
      click_id: id,
      ...commonStore,
      ...params,
      ...logData
    });
  });
  const effect = options.immediate ? xwxLog.sendBatchLogsImmediate : xwxLog.sendBatchLogs;
  effect(reportData);
}
